import { useEffect, useState } from "react";
import axios from "axios";
import { CalendarClock, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { useSearchParams } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CalendarConnect = ({ token }) => {
  const [status, setStatus] = useState(null);
  const [params, setParams] = useSearchParams();
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    axios.get(`${API}/calendar/status`, { headers }).then((r) => setStatus(r.data)).catch(() => {});
    if (params.get("calendar") === "connected") {
      toast.success("Google Calendar connected", { description: "Meet links will be generated automatically for new bookings." });
      params.delete("calendar");
      setParams(params, { replace: true });
    }
  }, []);

  const connect = async () => {
    try {
      const { data } = await axios.get(`${API}/oauth/calendar/login`, { headers });
      window.open(data.authorization_url, "_blank");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Calendar not configured");
    }
  };

  if (!status) return null;
  return status.connected ? (
    <span
      className="flex items-center gap-2 border border-emerald-600/30 bg-emerald-600/10 rounded-full px-5 py-2.5 text-xs text-emerald-700"
      data-testid="calendar-connected-badge"
    >
      <CheckCircle2 size={13} /> Meet: {status.email}
    </span>
  ) : (
    <button
      onClick={connect}
      className="flex items-center gap-2 border border-slate-200 rounded-full px-5 py-2.5 text-xs text-slate-700 hover:border-amber-600/50 transition-colors"
      data-testid="calendar-connect-button"
    >
      <CalendarClock size={13} /> Connect Google Meet
    </button>
  );
};

export default CalendarConnect;
